import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/key-account-products',
    name: 'keyAccountProducts',
    component: () =>
      import('@/views/restricted/key-account-products/KeyAccountProductLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_KEY_ACCOUNT_PRODUCT_READ_PERMISSION'],
      menuSelected: 'key-account-products'
    }
  },
  {
    path: '/key-account-products/create',
    name: 'keyAccountProductCreate',
    component: () =>
      import('@/views/restricted/key-account-products/product/KeyAccountProductCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_KEY_ACCOUNT_PRODUCT_CREATE_PERMISSION'],
      menuSelected: 'key-account-products'
    }
  },
  {
    path: '/key-account-products/:keyAccountProductId',
    name: 'keyAccountProductDetail',
    component: () =>
      import(
        '@/views/restricted/key-account-products/product/KeyAccountProductDetailLayoutView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_KEY_ACCOUNT_PRODUCT_REQUEST_DRAFT_REVIEW_PERMISSION'],
      menuSelected: 'key-account-products'
    }
  },
  {
    path: '/key-account-products/request-drafts/:requestDraftId',
    name: 'keyAccountProductRequestDraftReview',
    component: () =>
      import(
        '@/views/restricted/key-account-products/request-draft/KeyAccountProductRequestDraftReviewView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_KEY_ACCOUNT_PRODUCT_REQUEST_DRAFT_REVIEW_PERMISSION'],
      menuSelected: 'key-account-products'
    }
  },
  {
    path: '/key-account-products/:keyAccountProductId/edit',
    name: 'keyAccountProductUpdate',
    component: () =>
      import('@/views/restricted/key-account-products/product/KeyAccountProductUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_KEY_ACCOUNT_PRODUCT_UPDATE_PERMISSION'],
      menuSelected: 'key-account-products'
    }
  }
]
